import type { DashboardMessageId } from "./dashboard.fr";

/** Tableau de bord in English. Same keys and {placeholders} as dashboard.fr.ts. */
export const dashboardEn: Record<DashboardMessageId, string> = {
  "dashboard.greeting": "Hello, {name}",
  "dashboard.subtitle": "{date} · Conakry",
  "dashboard.generatedAt": "Figures read at {time} (up to a minute behind).",
  "dashboard.refresh": "Refresh",
  "dashboard.refreshing": "Refreshing…",
  "dashboard.loading": "Loading the dashboard…",
  "dashboard.loadFailed": "Couldn't load the dashboard.",
  "dashboard.alertsAria": "To handle now",
  "dashboard.alert.open": "Open →",
  "dashboard.alert.critical_report_open.tag": "Critical",
  "dashboard.alert.critical_report_open.text": "{count} open critical report(s).",
  "dashboard.alert.critical_report_open.review":
    "{count} person(s) suspended until a staff decision; first review due by {date}.",
  "dashboard.alert.suspension_review_overdue.tag": "Review overdue",
  "dashboard.alert.suspension_review_overdue.text":
    "{count} suspension(s) have passed their review deadline (oldest: {date}). The people stay suspended until you decide.",
  "dashboard.alert.cases_past_deadline.tag": "Late",
  "dashboard.alert.cases_past_deadline.text": "{count} case(s) have passed the first-response deadline ({hours} h).",
  "dashboard.alert.thin_coverage.tag": "Supply",
  "dashboard.alert.thin_coverage.text":
    "{trade} in {city}: {requests} requests today for {pros} available pro(s). That's where to recruit.",
  "dashboard.alert.failed_payments.tag": "Payments",
  "dashboard.alert.failed_payments.text": "{count} failed Orange Money payment(s) today.",

  "dashboard.card.demand": "Today's requests",
  "dashboard.card.demand.answered": "Answered within {hours} h",
  "dashboard.card.demand.unanswered": "Unanswered",
  "dashboard.card.demand.expired": "Expired",
  "dashboard.card.introductions": "Introductions",
  "dashboard.card.introductions.quotes": "Quotes sent",
  "dashboard.card.introductions.median": "Median time to first response",
  "dashboard.card.introductions.cancelled": "Cancelled before introduction",
  "dashboard.card.pros": "Verified pros",
  "dashboard.card.pros.unit": "active",
  "dashboard.card.pros.new": "New in 7 days",
  "dashboard.card.pros.waiting": "Awaiting verification",
  "dashboard.card.pros.suspended": "Suspended",
  "dashboard.card.money": "Fees collected",
  "dashboard.card.money.failed": "Failed Orange Money payments",
  "dashboard.card.money.approvals": "Pending approval requests",
  "dashboard.card.money.subscriptions": "Active monthly subscriptions",

  "dashboard.coverage": "Coverage by trade and commune",
  "dashboard.coverage.empty": "No requests today.",
  "dashboard.coverageFoot": "In red: fewer than half the requests answered in time. That's where to recruit.",
  "dashboard.col.trade": "Trade",
  "dashboard.col.commune": "Commune",
  "dashboard.col.requests": "Requests",
  "dashboard.col.pros": "Available pros",
  "dashboard.col.answered": "Answered < {hours} h",

  "dashboard.queues": "Queues",
  "dashboard.noQueues": "No queues for your roles.",
  "dashboard.queue.late_cases": "Late cases",
  "dashboard.queue.open_cases": "Open cases",
  "dashboard.queue.open_cases.meta": "{count} unassigned",
  "dashboard.queue.identity_verifications": "Identity verifications",
  "dashboard.queue.identity_verifications.meta": "oldest waiting for {age}",
  "dashboard.queue.safety_reports": "Open reports",
  "dashboard.queue.severity.critical": "{count} critical",
  "dashboard.queue.severity.high": "{count} high",
  "dashboard.queue.severity.medium": "{count} medium",
  "dashboard.queue.severity.low": "{count} low",
  "dashboard.queue.overdue_suspension_reviews": "Overdue suspension reviews",
  "dashboard.queue.overdue_suspension_reviews.meta": "still suspended until a decision",
  "dashboard.queue.payment_approvals": "Approval requests",
};
